import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  page: string | null;
  proceduresId: string;
  date_start: string;
  date_end: string;
  status: string;
  patientsId: string;
  employeesId: string;
};

const donwloadReportSchedulingsToExcel = async ({  page,date_end,date_start,employeesId,patientsId,proceduresId,status }: Props) => {
  const pageParams = `page=${page || 1}&status=${status}&date_start=${date_start}&date_end=${date_end}&employeesId=${employeesId}&patientsId=${patientsId}&proceduresId=${proceduresId}`;

  const response = await httpRequest.get(
    `/schedulings-report-in-xlsx?${pageParams}`,
    {
      responseType: "blob",
    }
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `report-schedulings.xlsx`);
  document.body.appendChild(link);
  link.click();
  if (link.parentNode) {
    link.parentNode.removeChild(link);
  } else {
    document.body.removeChild(link);
  }
};

export function useDownloadReportSchedulingsToExcelMutation(props: Props) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => donwloadReportSchedulingsToExcel(props),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["report-schedulings-download-excel", props.page],
      });
    },
  });
}
